import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title;
    const apply = (selector, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", value);
    };
    apply('meta[name="description"]', description);
    apply('meta[property="og:title"]', title);
    apply('meta[property="og:description"]', description);
    apply('meta[name="twitter:title"]', title);
    apply('meta[name="twitter:description"]', description);
  }, [title, description]);
  return null;
}
